import {
  MessageResponseDto,
  GetDiscountDto,
  DiscountControllerGet200Response,
  DiscountApiFp,
  CreateDiscountDto,
  DeleteDiscountDto,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseDiscountModel = DiscountControllerGet200Response;
export type GetDiscountModel = GetDiscountDto;
export type MutateResponseDiscountModel = MessageResponseDto;
export type CreateDiscountModel = CreateDiscountDto;
export type DeleteDiscountModel = DeleteDiscountDto;

export const apiDiscountFp = DiscountApiFp(apiConfig);
export const getDiscountController = apiDiscountFp.discountControllerGet;
export const createDiscountController = apiDiscountFp.discountControllerCreate;
export const deleteDiscountController = apiDiscountFp.discountControllerDelete;

export const QueryKeyDiscount = QueryKey.Discount;
